import { render, staticRenderFns } from "./ClientDirectoryList.vue?vue&type=template&id=bac13c8c&scoped=true&"
import script from "./ClientDirectoryList.vue?vue&type=script&lang=js&"
export * from "./ClientDirectoryList.vue?vue&type=script&lang=js&"
import style0 from "./ClientDirectoryList.vue?vue&type=style&index=0&id=bac13c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac13c8c",
  null
  
)

export default component.exports